export default __webpack_public_path__ + "static/media/12.9408a96d.jpg";